import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faPaperPlane,
  faArrowLeft,
  faCircleCheck
} from '@fortawesome/free-solid-svg-icons';
import { apiRequest } from '../../config/api';
import './fpassword.css';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    // Validação básica do email
    if (!email.includes('@') || !email.includes('.')) {
      setError(t('fpassword.invalidEmail'));
      return;
    }

    // Envia email de redefinição de senha via backend
    try {
      const data = await apiRequest('/auth/resend-reset-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });

      if (!data.success) {
        setError(t('fpassword.errorSend'));
        return;
      }
      setShowSuccess(true);
      setTimeout(() => {
        navigate('/email-verification', {
          state: { email }
        });
      }, 1500);
    } catch {
      setError(t('fpassword.errorSend'));
    }
  };

  return (
    <div className="password-recovery-page">
      <div className="recovery-container">
        <div className="logo-section">
          <div className="logo-wrapper">
            <span className="logo-text">Wappfy</span>
          </div>
        </div>

        <div className="recovery-content">
          <div className="recovery-header">
            <h1>{t('fpassword.title')}</h1>
            <p>{t('fpassword.instruction')}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>{t('fpassword.email')}</label>
              <div className="input-wrapper">
                <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('signup.placeholderEmail')}
                  required
                />
              </div>
            </div>
            {error && (
              <div style={{ color: '#ef4444', margin: '8px 0', fontSize: 15 }}>
                {error}
              </div>
            )}
            <button type="submit" className="send-link-button">
              <FontAwesomeIcon icon={faPaperPlane} />
              {t('fpassword.sendLink')}
            </button>
          </form>

          {showSuccess && (
            <div className="success-message">
              <FontAwesomeIcon icon={faCircleCheck} className="success-icon" />
              <p>{t('fpassword.success')}</p>
            </div>
          )}

          <div className="back-to-login-container">
            <button 
              className="back-to-login-button"
              onClick={() => navigate('/')}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>{t('fpassword.backToLogin')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;